import { render, staticRenderFns } from "./stockDaysMarket.vue?vue&type=template&id=3a20c497"
import script from "./stockDaysMarket.vue?vue&type=script&lang=js"
export * from "./stockDaysMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports